import i18n from '@/api/i18n/i18n';

const actionDict = {
  10: i18n.t('pages.actionDict.installation'),
  11: i18n.t('pages.actionDict.deletion'),
};

export const action = (val) => actionDict[val];
